export default __webpack_public_path__ + "media/images/cta_blocks/local_guide-8b63f3bb7e837e83f1ffbfea724cd880.jpg";